<div class="items" [sortablejs]="pages" [sortablejsOptions]="parent ? optionsPages : optionsLocales">
  <pages-tree-item [id]="page.id" [page]="page" [parent]="parent" *ngFor="let page of pages"></pages-tree-item>
</div>
